import React, { Component } from 'react';
import classnames from 'classnames';
import Draggable from 'react-draggable';
import { findDOMNode } from 'react-dom';

export default class ShowShape extends Component {
  constructor(props) {
    super(props);
    this.nodeRef = React.createRef();
    this.state = { bounds: null };
  }

  handleStart = () => {
    const { image } = this.props;
    const node = this.nodeRef.current;
    if (!node || !image) return;

    const playerRect = findDOMNode(image).getBoundingClientRect();
    const nodeRect = node.getBoundingClientRect();

    let bottomOffset = 0;

    const youtubeContainer = node.closest('.custom-youtube-player');
    if (youtubeContainer) {
      const controlsWrapper = youtubeContainer.querySelector('.youtube-controls-wrapper');
      if (controlsWrapper) {
        const controlsRect = controlsWrapper.getBoundingClientRect();
        if (controlsRect.bottom <= playerRect.bottom + 1 && controlsRect.top >= playerRect.top) {
          bottomOffset = controlsRect.height;
        }
      }
    }

    const videoReactContainer = node.closest('.animation-player');
    if (videoReactContainer && !youtubeContainer) {
      const controlBar = videoReactContainer.querySelector('.video-react-control-bar');
      if (controlBar) {
        const controlBarRect = controlBar.getBoundingClientRect();
        if (controlBarRect.bottom <= playerRect.bottom + 1 && controlBarRect.top >= playerRect.top) {
          bottomOffset = controlBarRect.height;
        }
      }
    }

    this.setState({
      bounds: {
        left: playerRect.left - nodeRect.left,
        top: playerRect.top - nodeRect.top,
        right: playerRect.right - nodeRect.right,
        bottom: playerRect.bottom - nodeRect.bottom - bottomOffset
      }
    });
  }

  handleStop = (e, ui) => {
    const { x, y, onMarkerUpdationCalled, marker_id, image, updateMakerShow } = this.props;
    const playerRect = findDOMNode(image).getBoundingClientRect();
    const newX = (playerRect.width * x) / 10000 + playerRect.left;
    const newY = (playerRect.height * y) / 10000 + playerRect.top;
    const updateX = ((newX + ui.lastX) - playerRect.left) / playerRect.width * 10000;
    const updateY = ((newY + ui.lastY) - playerRect.top) / playerRect.height * 10000;

    const clampedX = Math.max(0, Math.min(10000, updateX));
    const clampedY = Math.max(0, Math.min(10000, updateY));

    const data = {
      animation_marker: {
        x: clampedX,
        y: clampedY
      }
    };
    updateMakerShow(clampedX, clampedY, marker_id);
    onMarkerUpdationCalled(data, marker_id);
  }

  render() {
    const { x, y, width, height, shape, marker_id, borderColor, index } = this.props;
    const { bounds } = this.state;
    switch (shape) {
      case 'point':
        return (
          <Draggable
            position={{ x: 0, y: 0 }}
            bounds={bounds || undefined}
            onStart={this.handleStart}
            onStop={this.handleStop}>
            <div ref={this.nodeRef} className={`show-mark-shape marker-${marker_id}`} style={{ left: `${x / 100}%`, top: `${y / 100}%` }} data={marker_id}>
              <div className="border-none numerical-order-container d-flex justify-content-center align-items-center cursor-pointer" style={{backgroundColor: borderColor}}
                   onClick={() => $(`div.animation-marker-${marker_id}`).trigger('click')}
                   onMouseDown={(e) => e.stopPropagation()}
              >
                <div className="comment-no">
                  {index}
                </div>
              </div>
            </div>
          </Draggable>
        )
      case 'rect':
        return (
          <Draggable
            position={{ x: 0, y: 0 }}
            bounds={bounds || undefined}
            onStart={this.handleStart}
            onStop={this.handleStop}>
            <div ref={this.nodeRef} className={`show-mark-shape marker-${marker_id}`} style={{ left: `${x / 100}%`, top: `${y / 100}%`, width: `${width / 100}%`, height: `${height / 100}%` }} data={marker_id} onClick={() => $(`div.animation-marker-${marker_id}`).trigger('click')}>
              <div className="red-rect" style={{backgroundColor: "rgba(255, 239, 135, 0.2)", borderColor: borderColor}} onMouseDown={(e) => e.stopPropagation()}>
                <div className="border-none numerical-order-container d-flex justify-content-center align-items-center m-1" style={{backgroundColor: borderColor}}>
                  <div className="comment-no">
                    {index}
                  </div>
                </div>
              </div>
            </div>
          </Draggable>
        )
      case 'draw':
        return (
          <Draggable
            position={{ x: 0, y: 0 }}
            bounds={bounds || undefined}
            onStart={this.handleStart}
            onStop={this.handleStop}>
            <div ref={this.nodeRef} className={`show-mark-shape marker-${marker_id}`} style={{ left: `${x / 100}%`, top: `${y / 100}%`, width: `${width / 100}%`, height: `${height / 100}%` }} data={marker_id} onClick={() => $(`div.animation-marker-${marker_id}`).trigger('click')} onMouseDown={(e) => e.stopPropagation()}>
              <div className="border-none numerical-order-container d-flex justify-content-center align-items-center m-1" style={{backgroundColor: borderColor}}>
                  <div className="comment-no">
                    {index}
                  </div>
                </div>
            </div>
          </Draggable>
        )
    }
  }
}
